/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Recons } from '../models/recons';
import { ReconsCreate } from '../models/recons-create';
import { ReconsGetResp } from '../models/recons-get-resp';
import { AuthorizeForceMatchRecordsParams } from '../models/authorize-force-match-records-params';
import { AuthorizeRollbackRecordsParams } from '../models/authorize-rollback-records-params';
import { CloneSelectedReconParams } from '../models/clone-selected-recon-params';
import { DownloadReportParams } from '../models/download-report-params';
import { ExportCsvParams } from '../models/export-csv-params';
import { ExportXlsxParams } from '../models/export-xlsx-params';
import { ForceMatchRecordsParams } from '../models/force-match-records-params';
import { GenerateDisplayColumnsParams } from '../models/generate-display-columns-params';
import { GetDisplayColumnsParams } from '../models/get-display-columns-params';
import { GetExecutionDatesParams } from '../models/get-execution-dates-params';
import { GetGlReconAllDataParams } from '../models/get-gl-recon-all-data-params';
import { GetGlReconDataParams } from '../models/get-gl-recon-data-params';
import { GetGlSummaryParams } from '../models/get-gl-summary-params';
import { GetGlWiseSummaryParams } from '../models/get-gl-wise-summary-params';
import { GetProcessReconsParams } from '../models/get-process-recons-params';
import { GetReconAllDataParams } from '../models/get-recon-all-data-params';
import { GetReconDataParams } from '../models/get-recon-data-params';
import { GetReconSourceColumnsParams } from '../models/get-recon-source-columns-params';
import { GetReportsParams } from '../models/get-reports-params';
import { GetSummaryColumnsParams } from '../models/get-summary-columns-params';
import { GetSummaryParams } from '../models/get-summary-params';
import { GetMailSettingsParams } from '../models/get-mail-settings-params';
import { GetSimilarMatchesParams } from '../models/get-similar-matches-params';
import { ImportReconParams } from '../models/import-recon-params';
import { OperationAllDataParams } from '../models/operation-all-data-params';
import { OperationDataParams } from '../models/operation-data-params';
import { ProcessReconParams } from '../models/process-recon-params';
import { ReconsModelDeleteDataParams } from '../models/recons-model-delete-data-params';
import { RejectForceMatchRecordsParams } from '../models/reject-force-match-records-params';
import { RejectRollbackRecordsParams } from '../models/reject-rollback-records-params';
import { RollbackMatchedRecordsParams } from '../models/rollback-matched-records-params';
import { SaveReconParams } from '../models/save-recon-params';
import { SearchStringParams } from '../models/search-string-params';
import { UpdateReconRemarksFromFileParams } from '../models/update-recon-remarks-from-file-params';

@Injectable({
  providedIn: 'root',
})
export class ReconsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation reconsgetDisplayColumnsApiReconsGetDisplayColumnsPost
   */
  static readonly ReconsgetDisplayColumnsApiReconsGetDisplayColumnsPostPath = '/api/recons/getDisplayColumns';

  /**
   * Reconsgetdisplaycolumns.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetDisplayColumnsApiReconsGetDisplayColumnsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetDisplayColumnsApiReconsGetDisplayColumnsPost$Response(params: {
    body: GetDisplayColumnsParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetDisplayColumnsApiReconsGetDisplayColumnsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsgetdisplaycolumns.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetDisplayColumnsApiReconsGetDisplayColumnsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetDisplayColumnsApiReconsGetDisplayColumnsPost(params: {
    body: GetDisplayColumnsParams
  }): Observable<any> {

    return this.reconsgetDisplayColumnsApiReconsGetDisplayColumnsPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsoperationAllDataApiReconsOperationAllDataPost
   */
  static readonly ReconsoperationAllDataApiReconsOperationAllDataPostPath = '/api/recons/operationAllData';

  /**
   * Reconsoperationalldata.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsoperationAllDataApiReconsOperationAllDataPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsoperationAllDataApiReconsOperationAllDataPost$Response(params: {
    body: OperationAllDataParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsoperationAllDataApiReconsOperationAllDataPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsoperationalldata.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsoperationAllDataApiReconsOperationAllDataPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsoperationAllDataApiReconsOperationAllDataPost(params: {
    body: OperationAllDataParams
  }): Observable<any> {

    return this.reconsoperationAllDataApiReconsOperationAllDataPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsdownloadReportApiReconsDownloadReportPost
   */
  static readonly ReconsdownloadReportApiReconsDownloadReportPostPath = '/api/recons/downloadReport';

  /**
   * Reconsdownloadreport.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsdownloadReportApiReconsDownloadReportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsdownloadReportApiReconsDownloadReportPost$Response(params: {
    body: DownloadReportParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsdownloadReportApiReconsDownloadReportPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsdownloadreport.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsdownloadReportApiReconsDownloadReportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsdownloadReportApiReconsDownloadReportPost(params: {
    body: DownloadReportParams
  }): Observable<any> {

    return this.reconsdownloadReportApiReconsDownloadReportPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsimportReconApiReconsImportReconPost
   */
  static readonly ReconsimportReconApiReconsImportReconPostPath = '/api/recons/importRecon';

  /**
   * Reconsimportrecon.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsimportReconApiReconsImportReconPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsimportReconApiReconsImportReconPost$Response(params: {
    body: ImportReconParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsimportReconApiReconsImportReconPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsimportrecon.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsimportReconApiReconsImportReconPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsimportReconApiReconsImportReconPost(params: {
    body: ImportReconParams
  }): Observable<any> {

    return this.reconsimportReconApiReconsImportReconPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation getAllApiReconsGet
   */
  static readonly GetAllApiReconsGetPath = '/api/recons';

  /**
   * Get All.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllApiReconsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllApiReconsGet$Response(params?: {

    /**
     * Filter query to be executed against database.
     */
    'q'?: string;
    skip?: number;
    limit?: number;
    sort?: string;

    /**
     * Comma seperated list of fields to return.
     */
    fields?: string;
    download?: boolean;
  }): Observable<StrictHttpResponse<ReconsGetResp>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.GetAllApiReconsGetPath, 'get');
    if (params) {
      rb.query('q', params['q'], {});
      rb.query('skip', params.skip, {});
      rb.query('limit', params.limit, {});
      rb.query('sort', params.sort, {});
      rb.query('fields', params.fields, {});
      rb.query('download', params.download, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReconsGetResp>;
      })
    );
  }

  /**
   * Get All.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllApiReconsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllApiReconsGet(params?: {

    /**
     * Filter query to be executed against database.
     */
    'q'?: string;
    skip?: number;
    limit?: number;
    sort?: string;

    /**
     * Comma seperated list of fields to return.
     */
    fields?: string;
    download?: boolean;
  }): Observable<ReconsGetResp> {

    return this.getAllApiReconsGet$Response(params).pipe(
      map((r: StrictHttpResponse<ReconsGetResp>) => r.body as ReconsGetResp)
    );
  }

  /**
   * Path part for operation updateApiReconsPut
   */
  static readonly UpdateApiReconsPutPath = '/api/recons';

  /**
   * Update.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateApiReconsPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateApiReconsPut$Response(params: {
    body: Recons
  }): Observable<StrictHttpResponse<Recons>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.UpdateApiReconsPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Recons>;
      })
    );
  }

  /**
   * Update.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateApiReconsPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateApiReconsPut(params: {
    body: Recons
  }): Observable<Recons> {

    return this.updateApiReconsPut$Response(params).pipe(
      map((r: StrictHttpResponse<Recons>) => r.body as Recons)
    );
  }

  /**
   * Path part for operation createApiReconsPost
   */
  static readonly CreateApiReconsPostPath = '/api/recons/';

  /**
   * Create.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createApiReconsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createApiReconsPost$Response(params: {
    body: ReconsCreate
  }): Observable<StrictHttpResponse<Recons>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.CreateApiReconsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Recons>;
      })
    );
  }

  /**
   * Create.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createApiReconsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createApiReconsPost(params: {
    body: ReconsCreate
  }): Observable<Recons> {

    return this.createApiReconsPost$Response(params).pipe(
      map((r: StrictHttpResponse<Recons>) => r.body as Recons)
    );
  }

  /**
   * Path part for operation getApiReconsIdGet
   */
  static readonly GetApiReconsIdGetPath = '/api/recons/{id}';

  /**
   * Get.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiReconsIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiReconsIdGet$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<Recons>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.GetApiReconsIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Recons>;
      })
    );
  }

  /**
   * Get.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getApiReconsIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiReconsIdGet(params: {
    id: string;
  }): Observable<Recons> {

    return this.getApiReconsIdGet$Response(params).pipe(
      map((r: StrictHttpResponse<Recons>) => r.body as Recons)
    );
  }

  /**
   * Path part for operation deleteApiReconsIdDelete
   */
  static readonly DeleteApiReconsIdDeletePath = '/api/recons/{id}';

  /**
   * Delete.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiReconsIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiReconsIdDelete$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.DeleteApiReconsIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Delete.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteApiReconsIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiReconsIdDelete(params: {
    id: string;
  }): Observable<any> {

    return this.deleteApiReconsIdDelete$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsupdateReconRemarksFromFileApiReconsUpdateReconRemarksFromFilePost
   */
  static readonly ReconsupdateReconRemarksFromFileApiReconsUpdateReconRemarksFromFilePostPath = '/api/recons/updateReconRemarksFromFile';

  /**
   * Reconsupdatereconremarksfromfile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsupdateReconRemarksFromFileApiReconsUpdateReconRemarksFromFilePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsupdateReconRemarksFromFileApiReconsUpdateReconRemarksFromFilePost$Response(params: {
    body: UpdateReconRemarksFromFileParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsupdateReconRemarksFromFileApiReconsUpdateReconRemarksFromFilePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsupdatereconremarksfromfile.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsupdateReconRemarksFromFileApiReconsUpdateReconRemarksFromFilePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsupdateReconRemarksFromFileApiReconsUpdateReconRemarksFromFilePost(params: {
    body: UpdateReconRemarksFromFileParams
  }): Observable<any> {

    return this.reconsupdateReconRemarksFromFileApiReconsUpdateReconRemarksFromFilePost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconscloneSelectedReconApiReconsCloneSelectedReconPost
   */
  static readonly ReconscloneSelectedReconApiReconsCloneSelectedReconPostPath = '/api/recons/cloneSelectedRecon';

  /**
   * Reconscloneselectedrecon.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconscloneSelectedReconApiReconsCloneSelectedReconPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconscloneSelectedReconApiReconsCloneSelectedReconPost$Response(params: {
    body: CloneSelectedReconParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconscloneSelectedReconApiReconsCloneSelectedReconPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconscloneselectedrecon.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconscloneSelectedReconApiReconsCloneSelectedReconPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconscloneSelectedReconApiReconsCloneSelectedReconPost(params: {
    body: CloneSelectedReconParams
  }): Observable<any> {

    return this.reconscloneSelectedReconApiReconsCloneSelectedReconPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsdeleteDataApiReconsDeleteDataPost
   */
  static readonly ReconsdeleteDataApiReconsDeleteDataPostPath = '/api/recons/deleteData';

  /**
   * Reconsdeletedata.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsdeleteDataApiReconsDeleteDataPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsdeleteDataApiReconsDeleteDataPost$Response(params: {
    body: ReconsModelDeleteDataParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsdeleteDataApiReconsDeleteDataPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsdeletedata.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsdeleteDataApiReconsDeleteDataPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsdeleteDataApiReconsDeleteDataPost(params: {
    body: ReconsModelDeleteDataParams
  }): Observable<any> {

    return this.reconsdeleteDataApiReconsDeleteDataPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgetSummaryColumnsApiReconsGetSummaryColumnsPost
   */
  static readonly ReconsgetSummaryColumnsApiReconsGetSummaryColumnsPostPath = '/api/recons/getSummaryColumns';

  /**
   * Reconsgetsummarycolumns.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetSummaryColumnsApiReconsGetSummaryColumnsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetSummaryColumnsApiReconsGetSummaryColumnsPost$Response(params: {
    body: GetSummaryColumnsParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetSummaryColumnsApiReconsGetSummaryColumnsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsgetsummarycolumns.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetSummaryColumnsApiReconsGetSummaryColumnsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetSummaryColumnsApiReconsGetSummaryColumnsPost(params: {
    body: GetSummaryColumnsParams
  }): Observable<any> {

    return this.reconsgetSummaryColumnsApiReconsGetSummaryColumnsPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsrejectForceMatchRecordsApiReconsRejectForceMatchRecordsPost
   */
  static readonly ReconsrejectForceMatchRecordsApiReconsRejectForceMatchRecordsPostPath = '/api/recons/reject_force_match_records';

  /**
   * Reconsreject Force Match Records.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsrejectForceMatchRecordsApiReconsRejectForceMatchRecordsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsrejectForceMatchRecordsApiReconsRejectForceMatchRecordsPost$Response(params: {
    body: RejectForceMatchRecordsParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsrejectForceMatchRecordsApiReconsRejectForceMatchRecordsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsreject Force Match Records.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsrejectForceMatchRecordsApiReconsRejectForceMatchRecordsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsrejectForceMatchRecordsApiReconsRejectForceMatchRecordsPost(params: {
    body: RejectForceMatchRecordsParams
  }): Observable<any> {

    return this.reconsrejectForceMatchRecordsApiReconsRejectForceMatchRecordsPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsrejectRollbackRecordsApiReconsRejectRollbackRecordsPost
   */
  static readonly ReconsrejectRollbackRecordsApiReconsRejectRollbackRecordsPostPath = '/api/recons/reject_rollback_records';

  /**
   * Reconsreject Rollback Records.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsrejectRollbackRecordsApiReconsRejectRollbackRecordsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsrejectRollbackRecordsApiReconsRejectRollbackRecordsPost$Response(params: {
    body: RejectRollbackRecordsParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsrejectRollbackRecordsApiReconsRejectRollbackRecordsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsreject Rollback Records.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsrejectRollbackRecordsApiReconsRejectRollbackRecordsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsrejectRollbackRecordsApiReconsRejectRollbackRecordsPost(params: {
    body: RejectRollbackRecordsParams
  }): Observable<any> {

    return this.reconsrejectRollbackRecordsApiReconsRejectRollbackRecordsPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsauthorizeForceMatchRecordsApiReconsAuthorizeForceMatchRecordsPost
   */
  static readonly ReconsauthorizeForceMatchRecordsApiReconsAuthorizeForceMatchRecordsPostPath = '/api/recons/authorize_force_match_records';

  /**
   * Reconsauthorize Force Match Records.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsauthorizeForceMatchRecordsApiReconsAuthorizeForceMatchRecordsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsauthorizeForceMatchRecordsApiReconsAuthorizeForceMatchRecordsPost$Response(params: {
    body: AuthorizeForceMatchRecordsParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsauthorizeForceMatchRecordsApiReconsAuthorizeForceMatchRecordsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsauthorize Force Match Records.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsauthorizeForceMatchRecordsApiReconsAuthorizeForceMatchRecordsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsauthorizeForceMatchRecordsApiReconsAuthorizeForceMatchRecordsPost(params: {
    body: AuthorizeForceMatchRecordsParams
  }): Observable<any> {

    return this.reconsauthorizeForceMatchRecordsApiReconsAuthorizeForceMatchRecordsPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgetReconDataApiReconsGetReconDataPost
   */
  static readonly ReconsgetReconDataApiReconsGetReconDataPostPath = '/api/recons/getReconData';

  /**
   * Reconsgetrecondata.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetReconDataApiReconsGetReconDataPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetReconDataApiReconsGetReconDataPost$Response(params: {
    body: GetReconDataParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetReconDataApiReconsGetReconDataPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsgetrecondata.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetReconDataApiReconsGetReconDataPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetReconDataApiReconsGetReconDataPost(params: {
    body: GetReconDataParams
  }): Observable<any> {

    return this.reconsgetReconDataApiReconsGetReconDataPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgetReconAllDataApiReconsGetReconAllDataPost
   */
  static readonly ReconsgetReconAllDataApiReconsGetReconAllDataPostPath = '/api/recons/getReconAllData';

  /**
   * Reconsgetreconalldata.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetReconAllDataApiReconsGetReconAllDataPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetReconAllDataApiReconsGetReconAllDataPost$Response(params: {
    body: GetReconAllDataParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetReconAllDataApiReconsGetReconAllDataPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsgetreconalldata.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetReconAllDataApiReconsGetReconAllDataPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetReconAllDataApiReconsGetReconAllDataPost(params: {
    body: GetReconAllDataParams
  }): Observable<any> {

    return this.reconsgetReconAllDataApiReconsGetReconAllDataPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgetSummaryApiReconsGetSummaryPost
   */
  static readonly ReconsgetSummaryApiReconsGetSummaryPostPath = '/api/recons/getSummary';

  /**
   * Reconsgetsummary.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetSummaryApiReconsGetSummaryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetSummaryApiReconsGetSummaryPost$Response(params: {
    body: GetSummaryParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetSummaryApiReconsGetSummaryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsgetsummary.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetSummaryApiReconsGetSummaryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetSummaryApiReconsGetSummaryPost(params: {
    body: GetSummaryParams
  }): Observable<any> {

    return this.reconsgetSummaryApiReconsGetSummaryPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsoperationDataApiReconsOperationDataPost
   */
  static readonly ReconsoperationDataApiReconsOperationDataPostPath = '/api/recons/operationData';

  /**
   * Reconsoperationdata.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsoperationDataApiReconsOperationDataPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsoperationDataApiReconsOperationDataPost$Response(params: {
    body: OperationDataParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsoperationDataApiReconsOperationDataPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsoperationdata.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsoperationDataApiReconsOperationDataPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsoperationDataApiReconsOperationDataPost(params: {
    body: OperationDataParams
  }): Observable<any> {

    return this.reconsoperationDataApiReconsOperationDataPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgenerateDisplayColumnsApiReconsGenerateDisplayColumnsPost
   */
  static readonly ReconsgenerateDisplayColumnsApiReconsGenerateDisplayColumnsPostPath = '/api/recons/generateDisplayColumns';

  /**
   * Reconsgeneratedisplaycolumns.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgenerateDisplayColumnsApiReconsGenerateDisplayColumnsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgenerateDisplayColumnsApiReconsGenerateDisplayColumnsPost$Response(params: {
    body: GenerateDisplayColumnsParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgenerateDisplayColumnsApiReconsGenerateDisplayColumnsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsgeneratedisplaycolumns.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgenerateDisplayColumnsApiReconsGenerateDisplayColumnsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgenerateDisplayColumnsApiReconsGenerateDisplayColumnsPost(params: {
    body: GenerateDisplayColumnsParams
  }): Observable<any> {

    return this.reconsgenerateDisplayColumnsApiReconsGenerateDisplayColumnsPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsauthorizeRollbackRecordsApiReconsAuthorizeRollbackRecordsPost
   */
  static readonly ReconsauthorizeRollbackRecordsApiReconsAuthorizeRollbackRecordsPostPath = '/api/recons/authorize_rollback_records';

  /**
   * Reconsauthorize Rollback Records.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsauthorizeRollbackRecordsApiReconsAuthorizeRollbackRecordsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsauthorizeRollbackRecordsApiReconsAuthorizeRollbackRecordsPost$Response(params: {
    body: AuthorizeRollbackRecordsParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsauthorizeRollbackRecordsApiReconsAuthorizeRollbackRecordsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsauthorize Rollback Records.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsauthorizeRollbackRecordsApiReconsAuthorizeRollbackRecordsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsauthorizeRollbackRecordsApiReconsAuthorizeRollbackRecordsPost(params: {
    body: AuthorizeRollbackRecordsParams
  }): Observable<any> {

    return this.reconsauthorizeRollbackRecordsApiReconsAuthorizeRollbackRecordsPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgetMailSettingsApiReconsGetMailSettingsPost
   */
  static readonly ReconsgetMailSettingsApiReconsGetMailSettingsPostPath = '/api/recons/get_mail_settings';

  /**
   * Reconsget Mail Settings.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetMailSettingsApiReconsGetMailSettingsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetMailSettingsApiReconsGetMailSettingsPost$Response(params: {
    body: GetMailSettingsParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetMailSettingsApiReconsGetMailSettingsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsget Mail Settings.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetMailSettingsApiReconsGetMailSettingsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetMailSettingsApiReconsGetMailSettingsPost(params: {
    body: GetMailSettingsParams
  }): Observable<any> {

    return this.reconsgetMailSettingsApiReconsGetMailSettingsPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgetExecutionDatesApiReconsGetExecutionDatesPost
   */
  static readonly ReconsgetExecutionDatesApiReconsGetExecutionDatesPostPath = '/api/recons/getExecutionDates';

  /**
   * Reconsgetexecutiondates.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetExecutionDatesApiReconsGetExecutionDatesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetExecutionDatesApiReconsGetExecutionDatesPost$Response(params: {
    body: GetExecutionDatesParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetExecutionDatesApiReconsGetExecutionDatesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsgetexecutiondates.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetExecutionDatesApiReconsGetExecutionDatesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetExecutionDatesApiReconsGetExecutionDatesPost(params: {
    body: GetExecutionDatesParams
  }): Observable<any> {

    return this.reconsgetExecutionDatesApiReconsGetExecutionDatesPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgetReconSourceColumnsApiReconsGetReconSourceColumnsPost
   */
  static readonly ReconsgetReconSourceColumnsApiReconsGetReconSourceColumnsPostPath = '/api/recons/getReconSourceColumns';

  /**
   * Reconsgetreconsourcecolumns.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetReconSourceColumnsApiReconsGetReconSourceColumnsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetReconSourceColumnsApiReconsGetReconSourceColumnsPost$Response(params: {
    body: GetReconSourceColumnsParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetReconSourceColumnsApiReconsGetReconSourceColumnsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsgetreconsourcecolumns.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetReconSourceColumnsApiReconsGetReconSourceColumnsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetReconSourceColumnsApiReconsGetReconSourceColumnsPost(params: {
    body: GetReconSourceColumnsParams
  }): Observable<any> {

    return this.reconsgetReconSourceColumnsApiReconsGetReconSourceColumnsPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgetGlSummaryApiReconsGetGlSummaryPost
   */
  static readonly ReconsgetGlSummaryApiReconsGetGlSummaryPostPath = '/api/recons/getGlSummary';

  /**
   * Reconsgetglsummary.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetGlSummaryApiReconsGetGlSummaryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetGlSummaryApiReconsGetGlSummaryPost$Response(params: {
    body: GetGlSummaryParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetGlSummaryApiReconsGetGlSummaryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsgetglsummary.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetGlSummaryApiReconsGetGlSummaryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetGlSummaryApiReconsGetGlSummaryPost(params: {
    body: GetGlSummaryParams
  }): Observable<any> {

    return this.reconsgetGlSummaryApiReconsGetGlSummaryPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsforceMatchRecordsApiReconsForceMatchRecordsPost
   */
  static readonly ReconsforceMatchRecordsApiReconsForceMatchRecordsPostPath = '/api/recons/force_match_records';

  /**
   * Reconsforce Match Records.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsforceMatchRecordsApiReconsForceMatchRecordsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsforceMatchRecordsApiReconsForceMatchRecordsPost$Response(params: {
    body: ForceMatchRecordsParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsforceMatchRecordsApiReconsForceMatchRecordsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsforce Match Records.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsforceMatchRecordsApiReconsForceMatchRecordsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsforceMatchRecordsApiReconsForceMatchRecordsPost(params: {
    body: ForceMatchRecordsParams
  }): Observable<any> {

    return this.reconsforceMatchRecordsApiReconsForceMatchRecordsPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsprocessReconApiReconsProcessReconPost
   */
  static readonly ReconsprocessReconApiReconsProcessReconPostPath = '/api/recons/processRecon';

  /**
   * Reconsprocessrecon.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsprocessReconApiReconsProcessReconPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsprocessReconApiReconsProcessReconPost$Response(params: {
    body: ProcessReconParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsprocessReconApiReconsProcessReconPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsprocessrecon.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsprocessReconApiReconsProcessReconPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsprocessReconApiReconsProcessReconPost(params: {
    body: ProcessReconParams
  }): Observable<any> {

    return this.reconsprocessReconApiReconsProcessReconPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconssearchStringApiReconsSearchStringPost
   */
  static readonly ReconssearchStringApiReconsSearchStringPostPath = '/api/recons/searchString';

  /**
   * Reconssearchstring.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconssearchStringApiReconsSearchStringPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconssearchStringApiReconsSearchStringPost$Response(params: {
    body: SearchStringParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconssearchStringApiReconsSearchStringPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconssearchstring.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconssearchStringApiReconsSearchStringPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconssearchStringApiReconsSearchStringPost(params: {
    body: SearchStringParams
  }): Observable<any> {

    return this.reconssearchStringApiReconsSearchStringPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsrollbackMatchedRecordsApiReconsRollbackMatchedRecordsPost
   */
  static readonly ReconsrollbackMatchedRecordsApiReconsRollbackMatchedRecordsPostPath = '/api/recons/rollback_matched_records';

  /**
   * Reconsrollback Matched Records.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsrollbackMatchedRecordsApiReconsRollbackMatchedRecordsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsrollbackMatchedRecordsApiReconsRollbackMatchedRecordsPost$Response(params: {
    body: RollbackMatchedRecordsParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsrollbackMatchedRecordsApiReconsRollbackMatchedRecordsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsrollback Matched Records.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsrollbackMatchedRecordsApiReconsRollbackMatchedRecordsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsrollbackMatchedRecordsApiReconsRollbackMatchedRecordsPost(params: {
    body: RollbackMatchedRecordsParams
  }): Observable<any> {

    return this.reconsrollbackMatchedRecordsApiReconsRollbackMatchedRecordsPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgetGlReconAllDataApiReconsGetGlReconAllDataPost
   */
  static readonly ReconsgetGlReconAllDataApiReconsGetGlReconAllDataPostPath = '/api/recons/getGlReconAllData';

  /**
   * Reconsgetglreconalldata.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetGlReconAllDataApiReconsGetGlReconAllDataPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetGlReconAllDataApiReconsGetGlReconAllDataPost$Response(params: {
    body: GetGlReconAllDataParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetGlReconAllDataApiReconsGetGlReconAllDataPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsgetglreconalldata.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetGlReconAllDataApiReconsGetGlReconAllDataPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetGlReconAllDataApiReconsGetGlReconAllDataPost(params: {
    body: GetGlReconAllDataParams
  }): Observable<any> {

    return this.reconsgetGlReconAllDataApiReconsGetGlReconAllDataPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgetProcessReconsApiReconsGetProcessReconsPost
   */
  static readonly ReconsgetProcessReconsApiReconsGetProcessReconsPostPath = '/api/recons/getProcessRecons';

  /**
   * Reconsgetprocessrecons.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetProcessReconsApiReconsGetProcessReconsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetProcessReconsApiReconsGetProcessReconsPost$Response(params: {
    body: GetProcessReconsParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetProcessReconsApiReconsGetProcessReconsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsgetprocessrecons.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetProcessReconsApiReconsGetProcessReconsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetProcessReconsApiReconsGetProcessReconsPost(params: {
    body: GetProcessReconsParams
  }): Observable<any> {

    return this.reconsgetProcessReconsApiReconsGetProcessReconsPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgetGlWiseSummaryApiReconsGetGlWiseSummaryPost
   */
  static readonly ReconsgetGlWiseSummaryApiReconsGetGlWiseSummaryPostPath = '/api/recons/getGlWiseSummary';

  /**
   * Reconsgetglwisesummary.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetGlWiseSummaryApiReconsGetGlWiseSummaryPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetGlWiseSummaryApiReconsGetGlWiseSummaryPost$Response(params: {
    body: GetGlWiseSummaryParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetGlWiseSummaryApiReconsGetGlWiseSummaryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsgetglwisesummary.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetGlWiseSummaryApiReconsGetGlWiseSummaryPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetGlWiseSummaryApiReconsGetGlWiseSummaryPost(params: {
    body: GetGlWiseSummaryParams
  }): Observable<any> {

    return this.reconsgetGlWiseSummaryApiReconsGetGlWiseSummaryPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsexportCsvApiReconsExportCsvPost
   */
  static readonly ReconsexportCsvApiReconsExportCsvPostPath = '/api/recons/exportCsv';

  /**
   * Reconsexportcsv.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsexportCsvApiReconsExportCsvPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsexportCsvApiReconsExportCsvPost$Response(params: {
    body: ExportCsvParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsexportCsvApiReconsExportCsvPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsexportcsv.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsexportCsvApiReconsExportCsvPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsexportCsvApiReconsExportCsvPost(params: {
    body: ExportCsvParams
  }): Observable<any> {

    return this.reconsexportCsvApiReconsExportCsvPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgetGlReconDataApiReconsGetGlReconDataPost
   */
  static readonly ReconsgetGlReconDataApiReconsGetGlReconDataPostPath = '/api/recons/getGlReconData';

  /**
   * Reconsgetglrecondata.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetGlReconDataApiReconsGetGlReconDataPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetGlReconDataApiReconsGetGlReconDataPost$Response(params: {
    body: GetGlReconDataParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetGlReconDataApiReconsGetGlReconDataPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsgetglrecondata.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetGlReconDataApiReconsGetGlReconDataPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetGlReconDataApiReconsGetGlReconDataPost(params: {
    body: GetGlReconDataParams
  }): Observable<any> {

    return this.reconsgetGlReconDataApiReconsGetGlReconDataPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgetReportsApiReconsGetReportsPost
   */
  static readonly ReconsgetReportsApiReconsGetReportsPostPath = '/api/recons/getReports';

  /**
   * Reconsgetreports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetReportsApiReconsGetReportsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetReportsApiReconsGetReportsPost$Response(params: {
    body: GetReportsParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetReportsApiReconsGetReportsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsgetreports.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetReportsApiReconsGetReportsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetReportsApiReconsGetReportsPost(params: {
    body: GetReportsParams
  }): Observable<any> {

    return this.reconsgetReportsApiReconsGetReportsPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconssaveReconApiReconsSaveReconPost
   */
  static readonly ReconssaveReconApiReconsSaveReconPostPath = '/api/recons/saveRecon';

  /**
   * Reconssaverecon.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconssaveReconApiReconsSaveReconPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconssaveReconApiReconsSaveReconPost$Response(params: {
    body: SaveReconParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconssaveReconApiReconsSaveReconPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconssaverecon.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconssaveReconApiReconsSaveReconPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconssaveReconApiReconsSaveReconPost(params: {
    body: SaveReconParams
  }): Observable<any> {

    return this.reconssaveReconApiReconsSaveReconPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsexportXlsxApiReconsExportXlsxPost
   */
  static readonly ReconsexportXlsxApiReconsExportXlsxPostPath = '/api/recons/exportXlsx';

  /**
   * Reconsexportxlsx.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsexportXlsxApiReconsExportXlsxPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsexportXlsxApiReconsExportXlsxPost$Response(params: {
    body: ExportXlsxParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsexportXlsxApiReconsExportXlsxPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsexportxlsx.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsexportXlsxApiReconsExportXlsxPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsexportXlsxApiReconsExportXlsxPost(params: {
    body: ExportXlsxParams
  }): Observable<any> {

    return this.reconsexportXlsxApiReconsExportXlsxPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation reconsgetSimilarMatchesApiReconsGetSimilarMatchesPost
   */
  static readonly ReconsgetSimilarMatchesApiReconsGetSimilarMatchesPostPath = '/api/recons/get_similar_matches';

  /**
   * Reconsget Similar Matches.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reconsgetSimilarMatchesApiReconsGetSimilarMatchesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetSimilarMatchesApiReconsGetSimilarMatchesPost$Response(params: {
    body: GetSimilarMatchesParams
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ReconsService.ReconsgetSimilarMatchesApiReconsGetSimilarMatchesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Reconsget Similar Matches.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reconsgetSimilarMatchesApiReconsGetSimilarMatchesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reconsgetSimilarMatchesApiReconsGetSimilarMatchesPost(params: {
    body: GetSimilarMatchesParams
  }): Observable<any> {

    return this.reconsgetSimilarMatchesApiReconsGetSimilarMatchesPost$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

}
